<div class="nav-container">
  <nav class="navbar navbar-expand-md navbar-light bg-light">
    <div class="container">
      <div class="navbar-brand"></div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        [attr.aria-expanded]="!isCollapsed"
        aria-label="Toggle navigation"
        (click)="isCollapsed = !isCollapsed"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div
        class="collapse navbar-collapse"
        id="navbarNav"
        [ngbCollapse]="isCollapsed"
      >
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a routerLink="/" class="nav-link btn">Home</a>
          </li>
          <li class="nav-item">
          <div ngbDropdown class="nav-link">
            <button type="button" class="btn" id="dropdownBasic1" ngbDropdownToggle>Schedules</button>
            <div ngbDropdownMenu class="dropdown-menu-nav dropdown-menu-left">
              <button (click)="goToLink('schedule')" ngbDropdownItem>View 2023 Football Schedule</button>
            </div>
          </div>
          </li>
          <li class="nav-item">
            <div ngbDropdown class="nav-link">
              <button type="button" class="btn" id="dropdownBasic1" ngbDropdownToggle>Admin</button>
              <div ngbDropdownMenu class="dropdown-menu-nav dropdown-menu-left">
                <button (click)="goToLink('connections')" ngbDropdownItem>Add or Remove Enterprise Connections</button>
                <button (click)="goToLink('organization')" ngbDropdownItem>View Organization Members</button>
              </div>
            </div>
            </li>
            <li class="nav-item">
              <a routerLink="/api-key" class="nav-link btn">API Key</a>
            </li>
        </ul>

        <ul class="navbar-nav d-none d-md-block">
          <!-- Login button: show if NOT authenticated -->
          <li
            class="nav-item"
            *ngIf="(auth.isAuthenticated$ | async) === false"
          >

            <div ngbDropdown class="d-inline-block">
              <button type="button" class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>Log In</button>
              <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
                <div (click)="loginWithRedirect()" class="dropdown-item org-list">
                  <div>
                    <img class="list-img" src="../../../assets/logo.png">
                  </div>
                  <button ngbDropdownItem>
                    Log in Globally
                  </button>
              </div>
                <!-- <button (click)="loginWithPasswordless('email')" ngbDropdownItem>Log in with Passwordless (Email)</button>
                <button (click)="loginWithPasswordless('sms')" ngbDropdownItem>Log in with Passwordless (SMS)</button> -->
                
                <div (click)="loginWithOrg(org.id)" class="dropdown-item org-list" *ngFor="let org of orgs">
                  <div>
                    <img class="list-img" src="{{org.branding.logo_url}}">
                  </div>
                  <button ngbDropdownItem>Log in to {{org.display_name}}</button>
                </div>
              </div>
            </div>
            <!-- <div ngbDropdown class="d-inline-block">
              <button (click)="goToLink('embedded-login')" type="button" class="btn btn-outline-primary" id="dropdownBasic2" ngbDropdownToggle>Log In (Embedded)</button>
            </div> -->
          </li>
          <!-- / Login button -->

          <!-- Fullsize dropdown: show if authenticated -->
          <li
            class="nav-item dropdown"
            *ngIf="auth.user$ | async as user"
            ngbDropdown
          >
            <a
              ngbDropdownToggle
              class="nav-link dropdown-toggle"
              id="profileDropDown"
              data-toggle="dropdown"
            >
              <!-- Profile image should be set to the profile picture from the id token -->
              <img
                [src]="user.picture"
                alt="Profile picture"
                class="nav-user-profile rounded-circle"
                style="width: 75px;"
              />
            </a>
            <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
              <!-- Show the user's full name from the id token here -->
              <div class="dropdown-header">
                {{ user.name }}
              </div>
              <a routerLink="/profile" class="dropdown-item dropdown-profile">
                <fa-icon [icon]="faUser" class="mr-3"></fa-icon> Profile
              </a>

              <div (click)="loginWithOrg(org.id)" class="dropdown-item org-list" *ngFor="let org of orgs">
                <div>
                  <img class="list-img" src="{{org.branding.logo_url}}">
                </div>
                <button ngbDropdownItem>Log in to {{org.display_name}}</button>
              </div>
  
              <button
                (click)="logout()"
                class="btn btn-link dropdown-item"
                id="qsLogoutBtn"
              >
                <fa-icon [icon]="faPowerOff" class="mr-3"></fa-icon> Log out
              </button>
            </div>
          </li>
          <!-- /Fullsize dropdown -->
        </ul>

        <!-- Responsive login button: show if NOT authenticated -->
        <ul
          class="navbar-nav d-md-none"
          *ngIf="(auth.isAuthenticated$ | async) === false"
        >
        <div ngbDropdown class="d-inline-block">
          <button type="button" class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>Log In</button>
          <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
            <button (click)="loginWithRedirect()" ngbDropdownItem>Log in Globally</button>            
            <div (click)="loginWithOrg(org.id)" class="dropdown-item org-list" *ngFor="let org of orgs">
              <div>
                <img class="list-img" src="{{org.branding.logo_url}}">
              </div>
              <button ngbDropdownItem>Log in to {{org.display_name}}</button>
            </div>
          </div>
        </div>
        </ul>
        <!-- /Responsive login button -->

        <!-- Responsive profile dropdown: show if authenticated -->
        <ul
          class="navbar-nav d-md-none justify-content-between"
          *ngIf="auth.user$ | async as user"
          style="min-height: 170px;"
        >
          <li class="nav-item">
            <span class="user-info">
              <!-- Profile image should be set to the profile picture from the id token -->
              <img
                alt="Profile picture"
                class="nav-user-profile d-inline-block rounded-circle mr-3"
                style="width: 75px;"
                [src]="user.picture"
              />
              <!-- Show the user's full name from the id token here -->
              <h6 class="d-inline-block">{{ user.name }}</h6>
            </span>
          </li>
          <li>
            <fa-icon [icon]="faUser" class="mr-3"></fa-icon>
            <a routerLink="/profile">Profile</a>
          </li>

          <li>
            <fa-icon [icon]="faPowerOff" class="mr-3"></fa-icon>
            <button
              class="btn btn-link p-0"
              id="qsLogoutBtn"
              (click)="logout()"
            >
              Log out
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
